import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TextInput from "@p1s/p1s-common-react/TextInput";
import CheckBox from "../../controls/CheckBox";
import SessionTimeoutAlert from "../../controls/SessionTimeoutAlert";
import * as actions from "../../actions/EmailAuthenticationActions";
import { validateEmail } from "../validation/AccountValidations";
import CookieManager from "../../utilities/CookieManager";
import { loginSteps } from "../../utilities/Constants";
import { isEnterPressed } from "../../utilities/EventsHelper";

export class LoginEmail extends Component {
    constructor (props) {
        super(props);

        const emailFromCookie = CookieManager.getEmailForLoginPage();
        let rememberMe = false;
        let email = props.email;
        if (emailFromCookie !== undefined) {
            email = emailFromCookie;
            rememberMe = true;
        }
        this.state = {
            email: email,
            validationError: undefined,
            rememberMe: rememberMe,
        };

        this.onEmailChange = this.onEmailChange.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.handleRememberEmailCheck = this.handleRememberEmailCheck.bind(this);
    }

    onEmailChange (event) {
        this.setState({ email: event.target.value.trim() });
    }

    onNext () {
        const validationResult = validateEmail(this.state.email);
        if (validationResult.isValid) {
            this.setState({ validationError: undefined });
            this.setEmailRememberCookie();
            this.props.startLoginByEmail(this.state.email).then(() => {
                CookieManager.removeSsoSiteId();
            });
        }
        else
            this.setState({ validationError: validationResult.error });
    }

    setEmailRememberCookie () {
        if (this.state.rememberMe) {
            CookieManager.setEmailForLoginPage(this.state.email);
        }
        else{
            CookieManager.removeEmailForLoginPage(this.state.email);
        }
    }

    onEnter (e) {
        isEnterPressed(e) ? this.onNext() : {};
    }

    isSlideActive () {
        return this.props.step === loginSteps.enterEmail;
    }

    handleRememberEmailCheck (e) {
        this.setState({ rememberMe: e.target.checked });
    }

    render () {
        const validationError = this.state.validationError;

        const isActive = this.isSlideActive();
        const blockClassName = isActive ? "slide slide-active" : "slide";
        const inputTabIndex = isActive ? 0 : -1;

        if (this.props.step !== loginSteps.enterEmail && this.props.step !== loginSteps.enterPassword)
            return null;

        return (
            <div className={blockClassName}>
                <div>
                    <div className="loginEmail-popup" name="enterEmail">
                        <div className="signIn-form-title">SoleSource<span className="trade-sign">&reg;</span> Sign-In</div>
                        <div className="input-title">Email address</div>
                        <SessionTimeoutAlert/>
                        <div className="input-row">
                            <TextInput name="email"
                                onChange={this.onEmailChange}
                                placeholder={"Enter Email"}
                                onKeyPress={this.onEnter}
                                error={validationError}
                                value={this.state.email}
                                autoFocus={isActive}
                                tabIndex={inputTabIndex}
                            />
                        </div>

                        <div className="button-container">
                            <button id="btnLoginEmailNext" className="btn btn-primary-action pull-right"
                                onClick={this.onNext} tabIndex={inputTabIndex}>
                                <i className="ion-android-send" />
                                Next
                            </button>
                        </div>

                        <div className="rememberCheckbox">
                            <CheckBox
                                id="rememberMe"
                                checked={this.state.rememberMe}
                                onChange={this.handleRememberEmailCheck}
                                title="Remember my email on this computer"/>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

LoginEmail.propTypes = {
    email: PropTypes.string,
    startLoginByEmail: PropTypes.func,
    step: PropTypes.string
};

const mapStateToProps = state => ({
    email: state.loginState.email,
    step: state.loginState.loginStep
});

const mapDispatchToProps = (dispatch) => {
    return ({
        startLoginByEmail: (email) => dispatch(actions.startLoginByEmail(email))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginEmail);
